__turbopack_context__.v({
  "app_light_theme": "product-specs-module-scss-module__kaN3Pq__app_light_theme",
  "productSpecs_group": "product-specs-module-scss-module__kaN3Pq__productSpecs_group",
});
